import React from 'react';
import Modal from 'react-modal';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Creators as toastActions } from '../../../../../store/ducks/toast';
import Colors from '../../../../../config/Colors';
import { Button } from '../../../../../components-reactjs/Button';
import { excludeTime } from '../../../api';

import {
    Container,
    Content,
    ItemInfoText,
    Header,
    HeaderTitle,
    Footer
} from './styles';

const customStyles = {
    content: {
        minHeight: 200,
        minWidth: 420,
        padding: 0,
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: 8,
        overflow: 'hidden'
    },
    overlay: {
        zIndex: 9998,
        backgroundColor: Colors.darkerTransparent
    }
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ ...toastActions }, dispatch);

export const ModalExcludeTime = connect(
    null,
    mapDispatchToProps
)(({
    addToast,
    idTipoEntregaRetirada,
    selectedDay,
    horario,
    modalValues,
    useValues
}) => {
    const [shouldModalOpen, setShouldModalOpen] = modalValues;
    const [weekTimeStates, setWeekTimeStates] = useValues;

    const closeExcludeTimeModal = () => setShouldModalOpen(false);

    const confirmExclude = async () => {
        const { status } = await excludeTime({
            idHorarioEntregaRetirada: horario.idHorarioEntregaRetirada,
            idTipoEntregaRetirada
        });

        if (status === 200) {
            const newWeekTimeStates = [...weekTimeStates];

            const indexOfDay = newWeekTimeStates.findIndex(
                (dia) => dia.tpDiaSemana === selectedDay.tpDiaSemana
            );

            const indexOfTime = selectedDay.horarios.findIndex(
                (time) =>
                    time.idHorarioEntregaRetirada ===
                    horario.idHorarioEntregaRetirada
            );

            selectedDay.horarios.splice(indexOfTime, 1);

            if (!selectedDay.horarios.length) selectedDay.fgAtivo = false;

            newWeekTimeStates[indexOfDay] = selectedDay;

            setWeekTimeStates([...newWeekTimeStates]);

            closeExcludeTimeModal();

            return addToast({
                text: 'Horário excluído com sucesso',
                more: 'OK',
                theme: 'error'
            });
        }
    };

    return (
        <Modal
            ariaHideApp={false}
            isOpen={shouldModalOpen}
            style={customStyles}
            onRequestClose={closeExcludeTimeModal}
            contentLabel="content-Modal"
        >
            <Container className="modal-exclude-time-content">
                <Header>
                    <HeaderTitle>Excluir horário?</HeaderTitle>
                </Header>
                <Content className="content">
                    <ItemInfoText>{`${
                        selectedDay.dsDiaSemana
                    }, ${horario.horaInicio.substr(
                        0,
                        5
                    )} - ${horario.horaFim.substr(0, 5)}`}</ItemInfoText>
                </Content>
                <Footer className="buttons">
                    <Button
                        onClick={closeExcludeTimeModal}
                        style={{
                            backgroundColor: `${Colors.grey_light}`,
                            color: `${Colors.dark}`,
                            border: `1px solid ${Colors.regular}`,
                            marginRight: 15,
                            minHeight: 45,
                            minWidth: 135,
                            fontWeight: 'bold'
                        }}
                        title="Cancelar"
                    />
                    <Button
                        onClick={confirmExclude}
                        style={{
                            minHeight: 45,
                            minWidth: 135,
                            fontWeight: 'bold'
                        }}
                        title="Excluir"
                    />
                </Footer>
            </Container>
        </Modal>
    );
});
